// node modules
import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';

// assets
import s from './InfoTile.scss';

class InfoTile extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    subTitle: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    align: PropTypes.string,
  };

  static defaultProps = {
    subTitle: '',
    value: null,
    align: 'center',
  };

  render() {
    const { title, value, subTitle, align } = this.props;

    return (
      <div className={`${s.infoTile} ${s.infoTile}--align-${align}`}>
        <div className="heading heading--size-18">{title}</div>
        <p className={s.infoTile__value}>{value}</p>
        {subTitle}
      </div>
    );
  }
}

export default withStyles(s)(InfoTile);
